"use client";
import { useId, Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import CheckBoxItem from "components/common/checkbox-item";

import styles from "./styles.module.css";

const ChexBoxGroup = ({ property, name, checkBoxClass, onChange, selected }) => {
  const id = useId();

  const handleOptionChange = (option, event) => {
    const isChecked = event.target.checked;
    const optionID = option.id;

    let newSelected = selected;

    if (!option.groupedValues) {
      const optionExists = selected.some((selectedItem) => selectedItem.id === optionID);
      newSelected = optionExists
        ? selected.filter((selectedItem) => selectedItem.id !== optionID)
        : [...selected, option];
    } else {
      const filteredOptions = option.groupedValues.filter((optionItem) =>
        isChecked
          ? !selected.some((selectedItem) => selectedItem.id === optionItem.id)
          : selected.some((selectedItem) => selectedItem.id === optionItem.id)
      );

      newSelected = isChecked
        ? [...selected, ...filteredOptions]
        : selected.filter(
            (selectedItem) => !filteredOptions.map((optionItem) => optionItem.id).includes(selectedItem.id)
          );
    }

    onChange(newSelected, property?.key);
  };

  const filterList = property?.config?.values || property;

  const isCheckedElement = (item) => selected.some((element) => element.id === item.id);

  const isCheckedParent = (item) =>
    item?.groupedValues
      ? item.groupedValues.every((filter) => selected.some((selectedItem) => selectedItem.id === filter.id))
      : selected.some((element) => element.id === item.id);

  return (
    <>
      {filterList.map((item, index) => {
        const checkboxClasses = classNames({
          [checkBoxClass]: checkBoxClass,
          [styles.parentCheckbox]: item?.groupedValues,
        });
        return (
          <Fragment key={index}>
            <CheckBoxItem
              key={`${id}+${index}`}
              title={item.name}
              name={name}
              checkBoxClass={checkboxClasses}
              onChange={(e) => handleOptionChange(item, e)}
              checked={isCheckedParent(item)}
            />
            {item?.groupedValues &&
              item.groupedValues.map((childValue, childIndex) => (
                <CheckBoxItem
                  key={`${id}+${childIndex}`}
                  title={childValue.value}
                  name={childValue.value}
                  checkBoxClass={styles.childCheckbox}
                  onChange={(e) => handleOptionChange(childValue, e)}
                  checked={isCheckedElement(childValue)}
                />
              ))}
          </Fragment>
        );
      })}
    </>
  );
};

ChexBoxGroup.propTypes = {
  property: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onChange: PropTypes.func,
  name: PropTypes.string,
  checkBoxClass: PropTypes.any,
  selected: PropTypes.array,
};

export default ChexBoxGroup;
